
const provinces = require('../../static/json/provinces')
const cities = require('../../static/json/cities')
const areas = require('../../static/json/areas')

const addess = []
const areasList = {}
const citiesList = {}
areas.map(obj => {
  if (!areasList[obj.cityCode]) {
    areasList[obj.cityCode] = []
  }
  areasList[obj.cityCode].push({ code: obj.code, name: obj.name })
})
cities.map(obj => {
  if (!citiesList[obj.provinceCode]) {
    citiesList[obj.provinceCode] = []
  }
  citiesList[obj.provinceCode].push({ code: obj.code, name: obj.name, items: areasList[obj.code] })
})
provinces.map(obj => {
  const item = {}
  item.code = obj.code
  item.name = obj.name
  item.items = citiesList[obj.code]
  addess.push(item)
})

module.exports = addess



// WEBPACK FOOTER //
// ./src/common/Address.js